import EcoImg from 'eco-design/base/eco-img';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function Screen4() {
    const { t } = useLang('theProductV2.Screen4');
    const webpOrJpg = useWebpOrJpg('#rapid-mag-Screen4-V2');

    return (
        <section
            className={`${css.comp}  GtmModuleData-section`}
            id="rapid-mag-Screen4-V2"
            data-section-id={'rapid-mag-Screen4-V2'}
            data-section-title={t('title')}
        >
            <div className="label">{t('label')}</div>
            <div className="title">{t('title')}</div>
            <div className="desc">{t('desc')}</div>
            <div className="tips">{t('tips')}</div>
            <div className="img-box">
                <EcoImg
                    pc={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1761547520546/Screen4.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1761547519995/Screen4.webp',
                    )}
                    h5={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1761547553714/Screen4-m.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1761547520264/Screen4-m.webp',
                    )}
                />
            </div>
        </section>
    );
}
